import { applyMiddleware, createStore, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import logger from 'redux-logger';
import authReducer from '../page/auth/redux/authReducer';

import publicReducer from './reducers/publicReducer';
import analysisReducer from 'page/dashboard/analysis/redux/reducers';
import signalReducer from 'page/dashboard/signal/redux/reducers';
import basketReducer from 'page/dashboard/basket/redux/reducers';
import accountReducer from 'page/dashboard/account/redux/reducers';
import supportReducer from 'page/dashboard/support/redux/reducers';
import stockReducer from 'page/dashboard/stock/redux/reducers';
import riskReducer from 'page/dashboard/risk/redux/reducers';
import inquiryReducer from 'page/dashboard/inquiry/redux/reducers';
import transformationReducer from 'page/dashboard/transformation/redux/reducers';
import aiChatReducer from 'page/dashboard/aiChat/redux/reducers';
import dashboardViewReducer from 'page/dashboard/dashboardView/redux/reducers';




const ConfigureStore = () => {
    const store = createStore(
        combineReducers({
          authReducer,
          publicReducer,
          analysisReducer,
          basketReducer,
          signalReducer,
          accountReducer,
          supportReducer,
          stockReducer,
          riskReducer,
          inquiryReducer,
          transformationReducer,
          aiChatReducer,
          dashboardViewReducer
        
        }), applyMiddleware( thunk)
        // }), applyMiddleware(logger, thunk)
    );
    return store;
};

export { ConfigureStore as default };
